import {
  CREATE_COUPON,
  CREATE_COUPON_SUCCESS,
  DELETE_COUPON,
  GET_ALL_COUPON_LIST,
  GET_ALL_COUPON_LIST_SUCCESS,
  GET_COUPON_BY_ID,
  GET_COUPON_BY_ID_SUCCESS,
  GET_COUPON_HISTORY,
  GET_COUPON_HISTORY_SUCCESS,
  UPDATE_COUPON,
  UPDATE_COUPON_SUCCESS,
} from '../storeTypes';

export const ActionGetAllCouponList = (payload, callBack) => {
  return {
    type: GET_ALL_COUPON_LIST,
    payload,
    callBack,
  };
};
export const ActionGetAllCouponListSuccess = payload => {
  return {
    type: GET_ALL_COUPON_LIST_SUCCESS,
    payload,
  };
};
export const ActionCreateCoupon = (payload, callBack) => {
  return {
    type: CREATE_COUPON,
    payload,
    callBack,
  };
};
export const ActionCreateCouponSuccess = payload => {
  return {
    type: CREATE_COUPON_SUCCESS,
    payload,
  };
};
export const ActionUpdateCoupon = (payload, callBack) => {
  return {
    type: UPDATE_COUPON,
    payload,
    callBack,
  };
};
export const ActionUpdateCouponSuccess = payload => {
  return {
    type: UPDATE_COUPON_SUCCESS,
    payload,
  };
};
export const ActionGetCouponByID = (payload, callBack) => {
  return {
    type: GET_COUPON_BY_ID,
    payload,
    callBack,
  };
};
export const ActionGetCouponByIDSuccess = payload => {
  return {
    type: GET_COUPON_BY_ID_SUCCESS,
    payload,
  };
};
export const ActionDeleteCoupon = (payload, callBack) => {
  return {
    type: DELETE_COUPON,
    payload,
    callBack,
  };
};
export const ActionGetCoupenHistory = (payload, callBack) => {
  return {
    type: GET_COUPON_HISTORY,
    payload,
    callBack,
  };
};
export const ActionGetCoupenHistorySuccess = payload => {
  return {
    type: GET_COUPON_HISTORY_SUCCESS,
    payload,
  };
};
ActionGetCoupenHistory